import { HawkersReportTranslations } from "./hawkers-report-pt-br";

export const HAWKERS_REPORT_EN_US: HawkersReportTranslations = {
	title: "Hawkers Panel",
	description: "See the general performance of hawkers on site",
	general: {
		title: "General Panel",
		hawkerSelect: "Select a hawker",
		totalizers: {
			launchedProductsTotal: "Total products launched",
			returnedProductsTotal: "Total products returned",
			commissionTotal: "Total commissions",
			salesTotal: "Total sales",
		},
		table: {
			sales: "Sales",
			devolutions: "Refunds",
			paymentMethod: "Payment methods",
			productsRelease: "Product release",
			productsCancellation: "Product cancellation",
			noReturnNoSalesProducts: "Products no return and no sale",
			columns: {
				product: "Product",
				quantity: "Quantity",
				unitValue: "Unit value",
				total: "Total",
				commission: "Commission",
				paymentMethod: "Payment method",
				value: "Value",
			},
		},
	},
	summary: {
		title: "Summary by session and cycle",
		summary: "Summary",
		filterBreak: "Show only sessions with cash breaks",
		filterClosure: "Show only sessions with pending closure",
		columns: {
			session: "Session",
			hawkerName: "Hawker",
			pub: {
				initial: "Opening bar",
				final: "Closing bar",
			},
			hawkerDocument: "Document",
			cycleCount: "Cycles",
			change: "Change",
			receivedValue: "Received value",
			break: "Cash break",
			openedAt: "Opening",
			closedAt: "Opening",
			openClosure: "Open closure",
			cycle: "Cycle",
			previousBalance: "Previous balance",
			closingValue: "Closing value",
			balance: "Final balance",
			cashierNameOpener: "Cashier opening",
			cashierNameCloser: "Cashier closing",
		},
	},
	ranking: {
		title: "Ranking",
		filename: "ranking",
		columns: {
			name: "Name",
			document: "Document",
			commission: "Commission",
			total: "Total Sold",
		},
	},
	releases: {
		title: "Launches by hawkers",
		quantityProducts: "Qty of products",
		totalValueReleases: "Total value",
		filename: "hawker-record-{{hawker}}",
		hawkerRecord: "Hawker record",
		name: "Hawker name",
		columns: {
			hawkerName: "Name",
			hawkerDocument: "Document",
			total: "Total",
			productName: "Product",
			quantity: "Quantity",
			value: "Unit value",
		},
	},
	cashierClosing: {
		title: "Hawker cashier closing",
		name: "Name",
		document: "Document",
		begin: "Opening",
		end: "Closing",
		closingValue: "Closing value",
		financialResume: "Financial summary",
		resume: "Summary",
		value: "Value",
		products: "Products",
		product: "Product",
		quantity: "Quantity",
		unitValue: "Unit value",
		total: "Total",
		paymentMethods: "Payment methods",
		paymentMethod: "Payment method",
		date: "Date and time",
		changeEntries: "Change Entries",
		bleedings: "Bleedings",
		cycleClosings: "Cycle Closings",
		sessionClosings: "Session Closings",
		financialSummaryTitles: {
			changeFundsValue: "Change funds total",
			bleedingsValue: "Bleedings total",
			cyclesReceivedValue: "Cycle totalizer",
			sessionsReceivedValue: "Session totalizer",
			cashValue: "Cash value",
			valueWithCashier: "Amount held by cashier",
			cashierDiffValue: "Cashier closed with breakage/surplus",
		},
		diffValue: "Cashier break/Surplus",
	},
	filter: {
		filter: "Filter",
		clickToFilter: "Click to filter",
		employee: {
			label: "Employee",
			description: "Enter employee name",
			title: "Filter by employee",
		},
		hawkerName: {
			label: "Hawker name",
			description: "Enter vendor name",
			title: "Filter by vendor name",
		},
		hawkerDocument: {
			label: "Hawker document",
			description: "Enter vendor document",
			title: "Filter by vendor document",
		},
		cashierName: {
			label: "Cashier name",
			description: "Enter cashier name",
			title: "Filter by cashier name",
		},
		cashierDocument: {
			label: "Cashier document",
			description: "Enter cashier document",
			title: "Filter by cash document",
		},
		eventTypes: {
			label: "Movement type",
			description: "Select a movement type",
			title: "Filter by movement type",
		},
		productName: {
			label: "Product name",
			description: "Enter product name",
			title: "Filter by product name",
		},
		barName: {
			label: "Bar name",
			description: "Enter bar name",
			title: "Filter by bar name",
		},
		cycleId: {
			label: "Cycle",
			description: "Enter cycle ID",
			title: "Filter by cycle",
			error: "Please enter a valid ID",
		},
		sessionId: {
			label: "Session",
			description: "Enter session ID",
			title: "Filter by session",
			error: "Please enter a valid ID",
		},
		employeeLogin: {
			label: "Employee login",
			description: "Enter employee login",
			title: "Filter by employee login",
		},
	},
	transactions: {
		title: "Hawkers Transactions",
		columns: {
			id: "ID of Movement",
			hawkerName: "Hawker Name",
			hawkerDocument: "Hawker Document",
			productId: "Product ID",
			productName: "Product",
			barId: "Bar ID",
			barName: "Bar Name",
			cashierId: "Cashier ID",
			cashierName: "Cashier Name",
			cashierDocument: "Cashier Document",
			employeeName: "Employee Name",
			cycleId: "Cycle",
			openedAt: "Opening",
			closedAt: "Closing",
			eventType: "Event Type",
			createdAt: "Date/time of Movement",
			quantity: "Quantity",
			amount: "Value",
			paymentMethod: "Payment Method",
			paymentValue: "Payment Value",
			unitValue: "Unit Value",
			totalValue: "Total Value",
			sessionId: "Session",
			discount: "Discount",
			commission: "Commission",
			balance: "Balance of cycle/session closure",
			employeeLogin: "Employee login",
			serial: "Serial of terminal",
			deviceId: "Device ID of terminal",
			productTotal: "Product total",
			hawkerEmployee: "Login of hawker employee",
			cashierEmployee: "Login of cashier employee",
		},
		filter: {
			actionsType: "Select a movement type",
			employee: "Employee name",
			hawker: "Hawker name or document",
			cashier: "Cashier name or document",
		},
		sessionOpening: "Session Opening",
		sessionClosure: "Session Closure",
		cycleOpening: "Cycle Opening",
		cycleClosure: "Cycle Closure",
		productRelease: "Hawker Release",
		sale: "Sales",
		bleeding: "Bleeding",
		changeFund: "Change Fund",
		devolution: "Devolutions",
		cashierOpening: "Cashier Opening",
		cashierClosure: "Cashier Closure",
		cancellation: "Cancellation",
	},
};
